module.exports = __webpack_public_path__ + "img/yellowLangIcon.d3998475.svg";